<template>
	<div class="user-pic-box">
		<div class="user-pic-wrap">
			<div class="user-pic-content">
			</div>
			<!-- <canvas id="canvas" class="gauss-background" v-show="showImg" crossOrigin="anonymous"></canvas> -->
		</div>
		<div
		 class="user-pic-bg"
		 @click="imgBtnClick"
		>
			<img
			 class="user-pic"
			 v-show="showImg"
			 :src="pic"
			 ref="img"
			>
		</div>
		<p class="user-pic-tit">头像，一个好工作的开始</p>
		<popup v-model="showSelectBox">
			<selext-box
			 v-model="showSelectBox"
			 @hidePop="hidePop"
			 @chooseImg="chooseImg"
			 @choose58pic="choose58pic"
			 @imgSelect="imgSelect"
			></selext-box>
		</popup>
		<preview
		 v-model="showPreview"
		 :imgSrc="pic"
		 @changImg="changImg"
		></preview>
		<cut-img
		 v-model="showCutBox"
		 :dataUrl="dataUrl"
		 @afterCrop="submit"
		 @chooseOther='chooseOther'
		></cut-img>
		<toast
		 v-model="showToast"
		 :time="time"
		>{{toastTip}}</toast>
		<loading v-model="showLoading"></loading>
	</div>
</template>
<script>
import { Popup, Toast, Loading } from "@58fe/v5";
import selextBox from "./selectBox";
import preview from "./preview";
import cutImg from "./cutImg";
import FixDirect from "./FixDirect";
// import uploadImg from './uploadImg';
// import gaussVag from '../../../util/gaussVag';
import * as types from "../../../store/mutation-types";
import { mapGetters } from "vuex";

export default {
	components: {
		Popup,
		Toast,
		Loading,
		selextBox,
		preview,
		cutImg
	},
	data() {
		return {
			dataUrl: "",
			showImg: false, // 是否有头像
			imgTip: "头像，一个好工作的开始",
			showSelectBox: false,
			showPreview: false,
			showCutBox: false,
			showToast: false,
			showLoading: false,
			toastTip: "头像上传成功",
			maxSize: 10, // 文件大小限制
			time: 1000,
			isIOS: navigator.userAgent.match(/iphone/i)
		};
	},
	computed: {
		...mapGetters(["pic", "uploadState", "originPic", "pagetypeLog"])
	},
	watch: {
		pic(val) {
			this.setPic(val);
		},
		originPic(val) {
			if (val) {
				this.dataUrl = val;
			}
		}
	},
	mounted() {
		this.setPic(this.pic);
	},
	methods: {
		setPic(val) {
			if (val !== "") {
				this.$refs.img.onload = () => {
					this.showImg = true;
					// gaussVag(val); // 模糊背景
					window.clickLog &&
						window.clickLog(
							"from=post_jianli_zhaopiansuccess_pre_new" +
								this.pagetypeLog
						);
				};
			}
		},
		imgBtnClick() {
			window.clickLog &&
				window.clickLog(
					"from=post_jianli_zhaopian_new" + this.pagetypeLog
				);
			if (this.pic === "") {
				this.showSelectBox = true;
			} else {
				this.showPreview = true;
			}
		},
		changImg() {
			this.showPop();
		},
		showPop() {
			this.showSelectBox = true;
		},
		hidePop() {
			this.showSelectBox = false;
		},
		choose58pic(imgUrl) {
			this.showSelectBox = false;
			this.chooseImg(imgUrl);
		},
		chooseImg(imgUrl) {
			this.$store.commit(types.CHANGE_BASICINFO, {
				key: "pic",
				value: imgUrl
			});
			this.toastTip = "头像上传成功";
			this.showToast = true;
		},
		chooseOther() {
			this.showSelectBox = true;
			this.dataUrl = "";
		},
		// 选择本地图片
		imgSelect(file) {
			let self = this;
			// 文件类型和大小控制
			if (!/^image/.test(file.type)) {
				this.toastTip = "图片格式有误";
				this.showToast = true;
				return false;
			} else if (file.size > this.maxSize * 1024 * 1024) {
				this.toastTip = `图片不能大于${this.maxSize}M`;
				this.showToast = true;
				return false;
			}

			// 看支持不支持FileReader
			if (!window.FileReader) {
				this.toastTip = "请升级浏览器或选择其他浏览器";
				this.showToast = true;
				return;
			}

			this.showLoading = true;

			// 旋转ios/三星手机竖图片
			let fixDirect = new FixDirect();
			fixDirect.init(file, function(base64Data) {
				// 如果是IOS，上传之后再裁剪
				if (self.isIOS) {
					self.uploadImg(base64Data);
				} else {
					self.showLoading = false;
					self.dataUrl = base64Data;
					self.showCutBox = true;
				}
			});
			this.showSelectBox = false;
		},
		// IOS上传原图
		async uploadImg(dataUrl) {
			if (dataUrl === "") {
				this.toastTip = "图片解析有误，请重新选择一张图片";
				this.showToast = true;
				return;
			}
			await this.$store.dispatch("uploadImg", {
				dataUrl: dataUrl,
				isOrigin: true
			});
			// 上传成功，显示裁剪框
			this.showLoading = false;
			if (this.originPic !== "") {
				this.showCutBox = true;
			} else {
				this.toastTip = "头像选择失败";
				this.showToast = true;
			}
		},
		// 裁剪之后上传
		async submit(dataUrl) {
			if (dataUrl === "") {
				this.toastTip = "图片解析有误，请重新选择一张图片";
				this.showToast = true;
				return;
			}
			this.showLoading = true;
			await this.$store.dispatch("uploadImg", {
				dataUrl: dataUrl,
				isOrigin: false
			});
			this.showCutBox = false;
			this.showLoading = false;
			if (this.uploadState) {
				this.toastTip = "头像上传成功";
			} else {
				this.toastTip = "头像上传失败";
			}
			this.showToast = true;
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
.user-pic-box {
	height: px2rem(200px);
	margin-bottom: px2rem(40px);
	background-size: cover;
	width: 100%;
}

.user-pic-wrap {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
	overflow: hidden;
}
.user-pic-content,
.gauss-background {
	width: 100%;
	height: px2rem(200px);
}
.user-pic-content {
	background: url(//img.58cdn.com.cn/m58/app58/m_static/img/job/resume/newReleaseImg/m_user_bg@2x.png)
		no-repeat;
	background-size: contain;
}

.user-pic-bg {
	width: px2rem(220px);
	height: px2rem(220px);
	margin: auto;
	display: block;
	border-radius: 50%;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	-ms-border-radius: 50%;
	position: relative;
	background: url(//img.58cdn.com.cn/m58/app58/m_static/img/job/resume/newReleaseImg/img_user_empty@2x.png)
		no-repeat;
	margin-top: px2rem(-160px);
	background-size: contain;
}

.active-bg,
.user-pic {
	width: px2rem(182px);
	height: px2rem(182px);
	margin: auto;
	border-radius: 50%;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	-ms-border-radius: 50%;
	position: relative;
	top: px2rem(18px);
	left: px2rem(18px);
}

.active-bg {
	background: rgba(0, 0, 0, 0.1);
	position: absolute;
	left: 0.4rem;
	z-index: 1000;
}

.user-pic-tit {
	font-size: px2rem(26px);
	color: #579be8;
	margin: auto;
	position: relative;
	text-align: center;
}
.v5-loading {
	background-color: rgba(255, 255, 255, 0);
}
</style>



// WEBPACK FOOTER //
// index.vue?4304a808